<template>
  <v-container class="d-flex flex-column ga-3">
    <UsageExample v-model="tab" :code="code" :tabs="tabs">
      <v-layout>
        <v-main height="450">
          <div class="d-flex flex-column align-center">
            <v-card elevation="4" class="ma-2" height="auto">
              <v-card-title class="font-weight-bold">Multi-Select</v-card-title>
              <v-card-text>
                <HxSelect
                  :label="label ? 'Filter by module' : undefined"
                  :optional-text="optionalText ? '(Optional)' : undefined"
                  :mandatory="mandatory ? true : undefined"
                  :placeholder="placeholder ? 'Select an option' : undefined"
                  :items="items.slice(0, showNumberOfItems)"
                  :model-value="selectedItems"
                  :helper-message="helperMessage ? 'Helper message' : undefined"
                  :error-messages="errorMessages ? 'Error message' : undefined"
                  :disabled="disabled ? true : undefined"
                  :width="width ? '300' : undefined"
                  :apply-button-text="applyButtonText ? 'Apply Module Filter' : undefined"
                  multiple
                />
              </v-card-text>
            </v-card>
            <v-card elevation="4" class="ma-2" height="auto">
              <v-card-title class="font-weight-bold">Single Select</v-card-title>
              <v-card-text>
                <HxSelect
                  :label="label ? 'Filter by module' : undefined"
                  :optional-text="optionalText ? '(Optional)' : undefined"
                  :mandatory="mandatory ? true : undefined"
                  :placeholder="placeholder ? 'Select an option' : undefined"
                  :items="items.slice(0, showNumberOfItems)"
                  :model-value="selectedItems"
                  :helper-message="helperMessage ? 'Helper message' : undefined"
                  :error-messages="errorMessages ? 'Error message' : undefined"
                  :disabled="disabled ? true : undefined"
                  :width="width ? '300' : undefined"
                  :apply-button-text="applyButtonText ? 'Apply Module Filter' : undefined"
                  single
                />
              </v-card-text>
            </v-card>
          </div>
        </v-main>
      </v-layout>
      <template #configuration>
        <div class="d-flex flex-column">
          <v-checkbox v-model="label" label="Label" />
          <v-checkbox v-model="optionalText" label="Optional Text" />
          <v-checkbox v-model="mandatory" label="Mandatory" />
          <v-checkbox v-model="placeholder" label="Placeholder" />
          <v-checkbox v-model="helperMessage" label="Helper Message" />
          <v-checkbox v-model="errorMessages" label="Error Messages" />
          <v-checkbox v-model="disabled" label="Disabled" />
          <v-checkbox v-model="width" label="Width" />
          <v-checkbox v-model="applyButtonText" label="Apply Button Text" />
          <v-select v-model="showNumberOfItems" :items="[19, 20]" label="Number of Items" />
        </div>
      </template>
    </UsageExample>
  </v-container>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixSelect',
  components: { UsageExample },
  setup() {
    const code = `
 <HxSelect
        :label="label ? 'Filter by module' : undefined"
        :optional-text="optionalText ? '(Optional)' : undefined"
        :mandatory="mandatory ? true : undefined"
        :placeholder="placeholder ? 'Select an option' : undefined"
        :items="[
          {
          title: 'United States',
          value: 'us'
          },
          {
          title: 'Canada',
          value: 'ca'
          }
        ]"       
        :model-value="[]"
        :helper-message="helperMessage ? 'Helper message' : undefined"
        :error-messages="errorMessages ? 'Error message' : undefined"
        :disabled="disabled ? true : undefined"
        :width="width ? '300' : undefined"
        :apply-button-text="applyButtonText ? 'Apply Module Filter' : undefined"
        multiple
      />

 <HxSelect
        :label="label ? 'Filter by module' : undefined"
        :optional-text="optionalText ? '(Optional)' : undefined"
        :mandatory="mandatory ? true : undefined"
        :placeholder="placeholder ? 'Select an option' : undefined"
        :items="[
          {
          title: 'United States',
          value: 'us'
          },
          {
          title: 'Canada',
          value: 'ca'
          }
        ]"       
        :model-value="[]"
        :helper-message="helperMessage ? 'Helper message' : undefined"
        :error-messages="errorMessages ? 'Error message' : undefined"
        :disabled="disabled ? true : undefined"
        :width="width ? '300' : undefined"
        :apply-button-text="applyButtonText ? 'Apply Module Filter' : undefined"
        single
      />
    `;
    return {
      code
    };
  },
  data() {
    return {
      tab: 'Select Usage',
      tabs: ['Select Usage'],
      items: [
        {
          title: 'United States',
          value: 'us'
        },
        {
          title: 'Canada',
          value: 'ca'
        },
        {
          title: 'Mexico',
          value: 'mx'
        },
        {
          title: 'United Kingdom',
          value: 'uk'
        },
        {
          title: 'Germany',
          value: 'de'
        },
        {
          title: 'France',
          value: 'fr'
        },
        {
          title: 'Japan',
          value: 'jp'
        },
        {
          title: 'Australia',
          value: 'au'
        },
        {
          title: 'India',
          value: 'in'
        },
        {
          title: 'Brazil',
          value: 'br'
        },
        {
          title: 'South Africa',
          value: 'za'
        },
        {
          title: 'Russia',
          value: 'ru'
        },
        {
          title: 'China',
          value: 'cn'
        },
        {
          title: 'Italy',
          value: 'it'
        },
        {
          title: 'Spain',
          value: 'es'
        },
        {
          title: 'Netherlands',
          value: 'nl'
        },
        {
          title: 'Sweden',
          value: 'se'
        },
        {
          title: 'Norway',
          value: 'no'
        },
        {
          title: 'Finland',
          value: 'fi'
        },
        {
          title: 'Denmark',
          value: 'dk'
        },
        {
          title: 'Poland',
          value: 'pl'
        }
      ],
      selectedItems: [],
      label: true,
      optionalText: undefined,
      mandatory: undefined,
      placeholder: true,
      helperMessage: undefined,
      errorMessages: undefined,
      disabled: undefined,
      width: true,
      applyButtonText: true,
      showNumberOfItems: 19
    };
  }
};
</script>
